import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Art } from './Art';
/**
 * Import paperwork: a stack of forms, the top one sealed in vermilion with the shop's 右, and
 * the hanko that sealed it standing beside the stack. 220 × 140.
 */ export function PaperworkHanko({ title, className }) {
    return /*#__PURE__*/ _jsxs(Art, {
        viewBox: "0 0 220 140",
        title: title,
        className: className,
        children: [
            /*#__PURE__*/ _jsx("ellipse", {
                className: "fsh",
                cx: "104",
                cy: "128",
                rx: "92",
                ry: "4"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fp",
                d: "M34 30h108v96H34Z",
                transform: "rotate(5 88 78)"
            }),
            /*#__PURE__*/ _jsx("path", {
                className: "fp",
                d: "M30 26h108v96H30Z",
                transform: "rotate(-3 84 74)"
            }),
            /*#__PURE__*/ _jsxs("g", {
                transform: "rotate(1 86 74)",
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        className: "fp",
                        d: "M32 22h108v102H32Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "thin",
                        d: "M42 34h56M42 44h88M42 54h80M42 64h88M42 74h60",
                        opacity: ".6"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "thin",
                        d: "M42 88h40v20H42ZM88 88h42v20H88Z",
                        opacity: ".6"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "thin",
                        d: "M46 98h18M92 98h22",
                        opacity: ".5"
                    }),
                    /*#__PURE__*/ _jsx("rect", {
                        className: "sb",
                        x: "108",
                        y: "30",
                        width: "22",
                        height: "22",
                        rx: "3",
                        strokeWidth: "2.4"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "sb",
                        d: "M112 37h15M121 33c-2 7-5 12-9 15M117 42h8.5v6.5H117Z",
                        strokeWidth: "2"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("g", {
                children: [
                    /*#__PURE__*/ _jsx("path", {
                        className: "fa",
                        d: "M164 48c0-6 5-10 12-10s12 4 12 10v12h-24Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "fc",
                        d: "M164 60h24v56h-24Z"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "thin",
                        d: "M164 72h24M164 104h24",
                        opacity: ".6"
                    }),
                    /*#__PURE__*/ _jsx("path", {
                        className: "fb",
                        d: "M162 116h28v8h-28Z"
                    })
                ]
            })
        ]
    });
}
